module.exports = __webpack_public_path__ + "img/3c958ce47fc4d3537ef64a2b75034fae.png";